import * as React from 'react';
import { useContext } from 'react';

import type { CareerRolesCollectionType } from 'bundles/unified-common/types/careerRoles';

export type ConsumerPathwayRelatedRolesContextType =
  | {
      relatedCareerRoles?: CareerRolesCollectionType;
      relatedCareerRolesLoading?: boolean;
    }
  | null
  | undefined;

const ConsumerPathwayRelatedRolesContext = React.createContext<ConsumerPathwayRelatedRolesContextType>(undefined);

export const useRelatedRoles = () => {
  return useContext(ConsumerPathwayRelatedRolesContext);
};

export default ConsumerPathwayRelatedRolesContext;
